import { useLocation, useNavigate, useParams, useSearchParams } from "react-router-dom";
import { Tabs } from "antd";
import { useEffect, useState } from "react";
import { LeftCircleFilled } from "@ant-design/icons";
import TenantApi from "../../../../api/TenantApi";
import ViewStateService from "../../../../services/view-state/ViewStateService";
import TenantInformation from "./components/tenant-information/TenantInformation";
import TenantFeatures from "./components/tenant-features/TenantFeatures";
import { GoBackText, GoBackWrapper, TenantDetailsWrapper, TenantNameTitle, TitleBar } from "./TenantDetails.styled";
import TenantDevices from "./components/tenant-devices/TenantDevices";
import TenantUsers from "./components/tenant-users/TenantUsers";

interface TenantDetailsProps {
    onClose: ()=> void,
    onComplete: ()=> void
}

const TenantDetails: React.FC<TenantDetailsProps> = (props)=> {
    // api
    let navigate = useNavigate();
    let location = useLocation();
    let viewStateService = ViewStateService.getInstance();
    let tenantApi = new TenantApi();

    // parameters
    let {tenantId} = useParams();
    let [searchParams] = useSearchParams();
    let defaultTabKey = searchParams.get('tab') || 'tenant-information';

    // state
    let [tenantView, setTenantView] = useState(null);

    // events
    let loadTenant = async ()=> {
        if(!tenantId) {
            return;
        }

        let tenantView = (await tenantApi.getTenantViewById(tenantId)).data.data;
        setTenantView(tenantView);
    }

    let onGoBack = ()=> {
        if(location.key=='default') {
            navigate("/tenant-management");
        } else {
            navigate(-1);
        }
    }
    
    useEffect(()=> {
        // set status bar title
        viewStateService.setStatusBarTitle('租户详情');

        // load device information according to device id parameter
        loadTenant();

    }, []);
    
    let tabItems = [
        {
            key: 'tenant-information',
            label: '租户信息',
            children: tenantView && <TenantInformation tenantView={tenantView} />
        },
        {
            key: 'feature-settings',
            label: '功能设置',
            children: tenantView && <TenantFeatures tenantView={tenantView} />
        },
        {
            key: 'tenant-devices',
            label: '租户设备',
            children: tenantView && <TenantDevices tenantView={tenantView} />
        },
        {
            key: 'tenant-users',
            label: '租户用户',
            children: tenantView && <TenantUsers tenantView={tenantView} />
        },
    ];

    // render
    return (
        <TenantDetailsWrapper>
            <TitleBar>
                <GoBackWrapper onClick={onGoBack}>
                    <LeftCircleFilled style={{fontSize: '20px'}} />
                    <GoBackText>返回</GoBackText>
                </GoBackWrapper>
                <TenantNameTitle>{tenantView?.tenant.name}</TenantNameTitle>
            </TitleBar>
    
            { tenantView && 
                <Tabs
                    defaultActiveKey={defaultTabKey}
                    items={tabItems}
                    style={{flex: '1 1 auto', overflow: 'hidden'}}
                />
            }
        </TenantDetailsWrapper>
    )
}

export default TenantDetails;

